export const Project = [
    {
        id:1,
        name:"Smart Material Gatepass System",
        description:"A system that helps track the movement/exchange of materials via gate-pass, acts as a digital receipt for the complete transaction.",
        tags:["react", "html", "css", "javascript"],        
        demo:"https://gatepass-hritamdutta18.vercel.app/",
        github:"https://github.com/hritamdutta18/gatepass"
    },
    {
        id:2,
        name:"Ethereum-based E-Voting Web Application",
        description:"A decentralized Ethereum-based e-voting system using Aadhaar number & OTP authentication.",
        tags:["react", "node", "express", "ganache", "truffle", "metamask", "solidity", "smart-contracts", "web3"],        
        demo:"",
        github:"https://github.com/hritamdutta18/Ethereum-based-E-Voting-WebApp"
    },
    {
        id:3,
        name:"Lane Prediction Optimization in VANET",
        description:"A study on the various existing approaches to overcome the problems on the general VANET network and an approach which could help to improve the overall efficiency of the VANET.",
        tags:["vanet", "sumo", "ns-3.34", "openstreetmaps"],        
        demo:"",
        github:""
    },
    {
        id:4,
        name:"BeeResume - An Automated Resume Builder",
        description:"BeeResume gives the user an automatically generated pre-designed resume, using a Multi-Step form.",
        tags:["react","bootstrap","node"],        
        demo:"https://bee-resume.herokuapp.com/",
        github:"https://github.com/hritamdutta18/bee-resume"
    },
    {
        id:5,
        name:"Diary",
        description:"A globally accessible personal diary that the writer can access and edit from anywhere.",
        tags:["react","node","mongodb","bootstrap","express"],   
        demo:"",     
        // demo:"https://diary-iwp.herokuapp.com/",
        github:"https://github.com/abhitcr1/IWPproject"        
    },
    {
        id:6,
        name:"SGGES '21 Website",
        description:"Website for the Virtual International Conference on Smart Grid and Green Energy Systems (SGGES '21), organized by VIT Vellore.",
        tags:["html","css","bootstrap","javascript"],        
        demo:"https://vit.ac.in/SGGES-21/Home_page/index.html",
        github:"https://github.com/ieee-ias-vit/SGGES-21/"
    },
    {
        id:7,
        name:"IEEE IAS Website",
        description:"Official website of IEEE IAS VIT Vellore, made by members of the chapter.",
        tags:["html","css","bootstrap","javascript","firebase"],        
        demo:"https://hritamdutta18.github.io/IEEE-IAS-Website-2021/",
        github:"https://github.com/hritamdutta18/IEEE-IAS-Website-2021"       
    },
    {
        id:8,
        name:"ZooMath",
        description:"ZooMath is a fun learning based web application that allows children to learn and practice multiplication tables and attend quizzes based on them.",
        tags:["html","css","javascript","bootstrap"],        
        demo:"https://hritamdutta18.github.io/Hackulus_Team_DASH/home/page.html",
        github:"https://github.com/hritamdutta18/Hackulus_Team_DASH"        
    },
    {
        id:9,
        name:"Diary in C",
        description:"A simple personal diary application made using C language.",
        tags:["c","cmd"],        
        demo:"",
        github:"https://github.com/hritamdutta18/diary"        
    },  
    {
        id:10,
        name:"CoviPrec",
        description:"This is my first ever website ! It enlists a few articles & precautions regarding COVID-19, along with a form for contact details. No back-end functionalities are included.",
        tags:["html","css","javascript"],        
        demo:"https://hritamdutta18.github.io/covid_prec/webpage.html",
        github:"https://github.com/hritamdutta18/covid_prec"        
    }  
] 
